<template>
    <span>
        <b-button
            v-if="canSetDefaultAgreement"
            class="align-baseline"
            title="Set Default Agreement"
            variant="default"
            @click="handleSetDefaultAgreementClick"
        >
            Set Default Agreement
        </b-button>
        <span v-else>{{ params.data.default_report_type_name }}</span>
    </span>
</template>

<script>

export default {
    computed: {
        canSetDefaultAgreement() {
            const reportTemplate = this.params.data;
            return !!(
                reportTemplate &&
                !reportTemplate.default_report_type_name &&
                reportTemplate.report_type &&
                reportTemplate.report_type.sysname === 'AGREEMENT'
            );
        },
    },
    methods: {
        handleSetDefaultAgreementClick() {
            this.params.setDefaultAgreement && this.params.setDefaultAgreement(this.params.data);
        },
    },
}
</script>